package com.iregained.site.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.iregained.site.components.layouts.PageLayout

@InitRoute
fun initHome_contentPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("home_content.md", FrontMatterElement.EmptyMap))
}

@Page("/home-content")
@Composable
fun Home_contentPage() {
    PageLayout {
        org.jetbrains.compose.web.dom.H1(attrs = { id("hello-from-ca") }) {
            org.jetbrains.compose.web.dom.Text("Hello from Ca")
        }
    }
}
